<template>
  <b-modal
    id="contract-sign-modal"
    :title="$t('contract.sign_up_contract')"
    :ok-title="$t('contract.approve')"
    :cancel-title="$t('generals.cancel')"
    @ok="saveClick"
    @show="onShow"
  >
    <validation-observer ref="contractValidations">
      <b-form-group :label="$t('contract.upload_signed_contract')+':'">
        <validation-provider
          #default="{ errors }"
          :name="$t('generals.file')"
          rules="required"
        >
          <b-form-file
            v-model="contract_file"
            :browse-text="$t('objects.select')"
            plain
            multiple
            :placeholder="$t('generals.no_file_chosen')"
            @input="fileChanged"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <div>
        <b-badge
          v-for="(file, index) in contract_file"
          :key="index"
          variant="warning"
          class="mr-1 mb-1"
        >
          <span>
            {{ file.name }}
          </span>
          <b-button
            class="p-25 ml-25"
            variant="warning"
            @click="removeFile(index)"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </b-badge>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormFile, BBadge, BButton,
} from 'bootstrap-vue'
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
import { mapActions } from 'vuex'

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BFormFile,
    BBadge,
    BButton,
  },
  props: {
    contract_id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      required,
      contract_file: null,
    }
  },
  methods: {
    ...mapActions('contracts', ['EDIT_CONTRACT']),
    ...mapActions('files', ['ADD_ATTACHMENT']),
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.contractValidations.validate().then(success => {
        if (success) {
          const fd = this.$_objectToFormData({
            id: this.contract_id,
            files: this.contract_file,
            sign_in: true,
            action: 'sign_in',
          })
          this.EDIT_CONTRACT(fd).then(() => {
            this.$_successToast(this.$t('generals.succesfuly'))
            this.$emit('success')
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
    fileChanged() {
      // console.log(this.contract_file)
    },
    removeFile(index) {
      this.contract_file.splice(index, 1)
    },
    onShow() {
      this.contract_file = null
    },
  },
}
</script>

<style>

</style>
